import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../context/I18nContext';
import { useConsent } from '../../context/ConsentContext';
import { clickableLinks } from '../../styles/colors';

const PublicFooter: React.FC = () => {
  const { t } = useI18n();
  const { openPreferences } = useConsent();

  return (
    <footer className="bg-white/80 backdrop-blur-md border-t border-gray-200 mt-auto">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-10 xl:px-12 py-6">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
          <p className="text-gray-500 text-xs sm:text-sm text-center sm:text-left">
            {t('landing.copyright')}
          </p>
          <nav
            className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1 sm:gap-x-3 text-xs text-gray-600"
            aria-label={t('landing.footerLegalNav')}
          >
            <Link to="/blog" className={`${clickableLinks} hover:underline whitespace-nowrap`}>
              {t('blog.nav')}
            </Link>
            <span className="text-gray-300 select-none" aria-hidden>
              |
            </span>
            <Link to="/contact" className={`${clickableLinks} hover:underline whitespace-nowrap`}>
              {t('landing.contact')}
            </Link>
            <span className="text-gray-300 select-none" aria-hidden>
              |
            </span>
            <Link to="/legal" className={`${clickableLinks} hover:underline whitespace-nowrap`}>
              {t('landing.legalMentions')}
            </Link>
            <span className="text-gray-300 select-none" aria-hidden>
              |
            </span>
            <Link to="/privacy" className={`${clickableLinks} hover:underline whitespace-nowrap`}>
              {t('landing.privacyPolicy')}
            </Link>
            <span className="text-gray-300 select-none" aria-hidden>
              |
            </span>
            <Link to="/terms" className={`${clickableLinks} hover:underline whitespace-nowrap`}>
              {t('landing.termsOfService')}
            </Link>
            <span className="text-gray-300 select-none" aria-hidden>
              |
            </span>
            <button
              type="button"
              onClick={openPreferences}
              className={`${clickableLinks} hover:underline whitespace-nowrap bg-transparent border-0 p-0 text-xs`}
            >
              {t('cookies.manageCookies')}
            </button>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;







